// Images get no right-click menu (Open image in new tab, Copy image, Save image as) and can't be dragged out.
// A linked image passes its events to the link instead (global.css), so cards keep "Open link in new tab".

const IMAGE = 'img, picture, canvas';

let installed = false;

const block = e => {
  const t = e.target;
  if (t instanceof Element && t.closest(IMAGE)) e.preventDefault();
};

export function guardImages() {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  document.addEventListener('contextmenu', block, true);
  document.addEventListener('dragstart', block, true);
}
